
      export default {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"width":"29","height":"28","fill":"none","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('circle',{attrs:{"cx":"14.698","cy":"14.062","fill":"#E42877","r":"13.726"}}),_c('path',{attrs:{"d":"M19.843 8.298c-4.243 0-5.013 2.752-5.013 5.765 0 3.012.748 5.764 5.013 5.764 4.243 0 4.99-2.752 4.99-5.764.022-3.013-.725-5.765-4.99-5.765zm0 8.885c-1.671 0-1.913-1.148-1.913-2.99 0-1.842.242-2.97 1.913-2.97 1.67 0 1.89 1.15 1.89 2.97.022 1.842-.22 2.99-1.89 2.99zM8.982 15.341h1.979v.195c0 1.236.043 1.799-1.473 1.799-1.407 0-1.891-.629-1.891-3.186 0-2.644.791-2.969 2-2.969.902 0 1.517.239 2.045.52l1.627-2.514c-.835-.52-2.089-.888-3.518-.888-3.935 0-5.21 1.864-5.21 5.765 0 3.402.923 5.764 4.66 5.764.66 0 1.232-.043 1.715-.13h2.815v-6.783H9.31l-.33 2.427z","fill":"#fff"}})])
          )
        }
      }
    